import { useEffect as e, useState as t } from "react";
//#region src/hooks/useScrollDirection.ts
function n(n = !1) {
	let [r, i] = t(null);
	return e(() => {
		let e = window.pageYOffset, t = () => {
			if (n) {
				r !== "up" && i("up");
				return;
			}
			let t = window.pageYOffset;
			if (t <= 0) {
				i("up"), e = 0;
				return;
			}
			let a = t > e ? "down" : "up";
			a !== r && Math.abs(t - e) > 5 && i(a), e = t;
		};
		return window.addEventListener("scroll", t, { passive: !0 }), t(), () => {
			window.removeEventListener("scroll", t);
		};
	}, [r, n]), r;
}
//#endregion
export { n as useScrollDirection };
